module.exports = __webpack_public_path__ + "assets/f3454b5823d87cd2fc4aff0d57a00697.png";